import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router'
import { Toaster } from '@/components/ui/Toaster'
import { I18nProvider } from '@/i18n'
import { RootStore, StoreProvider } from '@/stores'
import { router } from './router'

export function App() {
  const [store] = useState(() => new RootStore())

  // RequireAuth observes auth.status, so a mid-session expiry (failed refresh)
  // re-renders into a redirect to /login?next=… without extra wiring here.
  useEffect(() => {
    void store.auth.restore()
  }, [store])

  return (
    <I18nProvider>
      <StoreProvider store={store}>
        <RouterProvider router={router} />
        <Toaster />
      </StoreProvider>
    </I18nProvider>
  )
}
